import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { PhoneBook, AADUsers } from '../models/data.model';

@Pipe({
  name: 'phoneBookFilter'
})
@Injectable()
export class phoneBookFilter implements PipeTransform {
  transform(items: AADUsers[], args: any[]): any {
    if (args[0] !== null) {
      console.log('this is filter arg : ', args)
      return items.filter(item => {
        if (item.givenName)
          item.givenName.match(args[0])
        if (item.companyName)
          item.companyName.match(args[0])
        if (item.mail)
          item.mail.match(args[0])
        if (item.mobilePhone)
          item.mobilePhone.match(args[0])
        if (item.userPrincipalName)
          item.userPrincipalName.match(args[0])
        if (item.businessPhones)
          item.businessPhones.includes(args[0])
      }
      );
    }
    else
      return items;
  }
}